import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class TranslateConfigService {

  currentLang = new BehaviorSubject(false);


  constructor(
    private translate: TranslateService,
    private storage: Storage,
    private storageService: StorageService,
  ) { }

  getDefaultLanguage(){
    if (this.currentLang.value) {
      return this.currentLang.value;
    }
    else {
      let lang = this.translate.getBrowserLang();
      if (!lang) {
        lang = 'es';
      }
      this.translate.setDefaultLang(lang);
      this.storageService.get('lang').then(lang => {
        if (lang) {
          this.currentLang.next(lang);
          this.translate.setDefaultLang(lang);
        }
      })



    }
  }

  setLanguage(lang) {
    this.translate.use(lang);
    this.storageService.set('lang', lang);
    this.currentLang.next(lang);
  }

  getKey(key) {
    return this.translate.instant(key);
  }


}